import { createGlobalStyle } from 'styled-components'
// theme
import colors from 'themes/colors'
import { scrollbarsCSS } from 'themes/generic'
import { NProgressStyles } from 'themes/libs'

export const GlobalStyles = createGlobalStyle`
    ${NProgressStyles};
    ${scrollbarsCSS};

    html, body, #root {
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
    }

    html, body, #root {
        min-height: 100%;
        /* mobile viewport bug fix */
        height: -webkit-fill-available;
        font-size: 100%;
    }

    html {
        font-size: 16px;
        color: ${colors.gray900};
    }

    body {
        overflow: hidden;
    }
`
